import http from '@/plugins/axios';

export default {
  getUserList({ page = 1, size = 20, queryType, queryValue }) {
    return http.get({
      url: `/admin/trade/user/${page}/${size}`,
      data: {
        queryType,
        queryValue
      }
    });
  },
  updateVolunteer({ id, status }) {
    return http.post({
      url: `/admin/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status
      },
      dataType: 'form'
    });
  },
  changePage(val){
    this.queryData.pageNum = val;
    this.queryData2.pageNum=val;
    api.getUsers(this.queryData2).then(res => {
      console.log(res)
      this.dataListUser = res.data;
      this.total = res.data.total;
    })
  },
  getUserDetail1({ userId }) {
    return http.post({
      url: '/admin/trade/user/inviteDetail',
      data: {
        userId: userId
      },
      dataType: 'form'
    });
  },
  export({ userId}) {
    return http.post({
      url: '/admin/trade/user/export',
      data: {
        userId: userId
      },
      dataType: 'form',
      responseType: 'blob'
    });
  },
  updateInviteCode({ userId1 ,inviteCode1}) {
    return http.post({
      url: '/admin/trade/user/updateInvite',
      data: {
        userId: userId1,
        inviteCode: inviteCode1

      },
      dataType: 'form'
    });
  },
  resetPassword({ id }) {
    return http.post({
      url: '/admin/trade/user/resetPassword',
      data: {
        id: id
      },
      dataType: 'form'
    });
  },
  resetGoogle({ id }) {
    return http.post({
      url: '/admin/trade/user/resetGoogleAuth',
      data: {
        id: id
      },
      dataType: 'form'
    });
  },
  cleanLoginForbid({ id }) {
    return http.get({
      url: 'admin/trade/user/cleanLoginForbid',
      data: {
        id: id
      },
    });
  },
  updateBlocking({ id, status }) {
    return http.post({
      url: '/admin/trade/user/updateUserStatus',
      data: {
        id,
        userStatus: status
      },
      dataType: 'form'
    });
  }
};
